import { API_HOST } from '../config/host';

// 图片地址转绝对路径：相对路径拼接 host，http/https 开头不处理
export function imgUrl(path) {
  if (!path) return '';
  if (/^https?:\/\//.test(path)) return path;
  // return 'https://yalan.joydesk.cn' + path;
  return API_HOST + path;
}
